<template>
  <div>
    <template v-for="(slide, index) in formattedSlides" :key="index">
      <div class="api-slide-container">
        <div>
          <div class="thumbnail-wrapper" @click="openModal(slide.thumbnail)">
            <div class="api-slide-picture">
              <img :src="slide.thumbnail" :alt="'slide thumbnail'" />
            </div>
          </div>
          <p class="api-slide-number">Slide {{ slide.meta }}</p>
        </div>

        <div class="api-slide-intro">
          <p>
            {{ slide.notes }}
          </p>
        </div>
      </div>

      <div
        v-if="hasDivider(formattedSlides, index)"
        class="api-slide-divider"
      ></div>
    </template>

    <div v-if="showModal" class="api-slide-modal">
      <div class="api-slide-modal-overlay" @click="closeModal">
        <div class="api-slide-modal-content" @click.stop>
          <span class="api-slide-modal-close" @click="closeModal">&times;</span>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: fit-content;
              height: 60vh;
              align-items: end;
            "
          >
            <img
              :src="selectedImage"
              alt="Modal Image"
              class="modal-image"
              style="width: 100%"
            />
            <div
              style="display: flex; justify-content: flex-end; margin-top: 1rem"
            >
              <template v-if="isLoading">
                <v-progress-circular
                  indeterminate
                  color="white"
                  size="20"
                ></v-progress-circular>
              </template>
              <template v-else>
                <button
                  class="modal-close-text"
                  @click="copyToDrive"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;
                  "
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M2 5.31818C2 4.03741 3.03803 3 4.31818 3H6.34636C6.62251 3 6.84636 3.22386 6.84636 3.5C6.84636 3.77614 6.62251 4 6.34636 4H4.31818C3.59015 4 3 4.58986 3 5.31818V11.6818C3 12.4101 3.59015 13 4.31818 13H10.6818C11.4098 13 12 12.4101 12 11.6818V9.65455C12 9.3784 12.2239 9.15455 12.5 9.15455C12.7761 9.15455 13 9.3784 13 9.65455V11.6818C13 12.9626 11.962 14 10.6818 14H4.31818C3.03803 14 2 12.9626 2 11.6818V5.31818Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9 2.5C9 2.22386 9.22386 2 9.5 2H13.5C13.7761 2 14 2.22386 14 2.5V6.5C14 6.77614 13.7761 7 13.5 7C13.2239 7 13 6.77614 13 6.5V3H9.5C9.22386 3 9 2.77614 9 2.5Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.4891 2.5269C13.6841 2.72248 13.6836 3.03906 13.488 3.23401L8.85298 7.85401C8.6574 8.04895 8.34082 8.04844 8.14587 7.85286C7.95093 7.65728 7.95144 7.3407 8.14702 7.14575L12.782 2.52575C12.9776 2.33081 13.2942 2.33132 13.4891 2.5269Z"
                      fill="white"
                    />
                  </svg>
                  View this slide on your drive
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, defineProps } from "vue";
import lessonPackageService from "../services/lessonPackageService";
import { useStore } from "vuex";

const props = defineProps({
  activity: {
    type: Array,
    required: true,
    default: () => [],
  },
  driveLink: {
    type: String,
    required: false,
  },
  slideId: {
    type: String,
    required: true,
  },
});

const driveLink = ref(props.driveLink);
const store = useStore();
const user = computed(() => store.state.user);

const formattedSlides = computed(() => {
  // Logika format slides disini
  return props.activity;
});

const isLoading = ref(false);

const hasDivider = (slides, index) => {
  const hasMoreThanOneItem = slides.length > 1;
  const isNotLastItem = index < slides.length - 1;
  return hasMoreThanOneItem && isNotLastItem;
};

const showModal = ref(false);
const selectedImage = ref("");

const openModal = (image) => {
  selectedImage.value = image;
  showModal.value = true;
};

const copyToDrive = () => {
  const link = props.driveLink;
  isLoading.value = true;
  if (link) {
    window.open(link);
    isLoading.value = false;
  } else {
    isLoading.value = true;
    lessonPackageService
      .copySlideToDrive(user.value?.email, props.slideId)
      .then((response) => {
        const data = response.data?.data;
        console.log(data, "data");
        window.open(data.url);
        if (data?.url?.includes("drive.google.com")) {
          window.location.reload();
          driveLink.value = data.url;
        }
      })
      .catch(() => console.error)
      .finally(() => (isLoading.value = false));
  }
};

const closeModal = () => {
  showModal.value = false;
  selectedImage.value = "";
};
</script>

<style scoped>
.api-slide-container {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 8px;
  background-color: var(--white-hover-1);
  border-radius: 8px;
  font-family: "League Spartan", sans-serif;
  color: var(--black-body-text) !important;
}

.api-slide-picture {
  width: 469px;
  height: 265px;
  border-radius: 0.75rem;
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
}

.api-slide-picture > * {
  width: 100%;
  height: 100%;
  border-radius: 0.75rem;
  object-fit: cover;
}

.api-slide-number {
  margin-top: 0.5rem;
  font-size: var(--fs-medium);
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.08px;
  color: var(--black-body-text);
}

.api-slide-intro {
  flex: 1 0 0;
  min-height: 1px;
  min-width: 1px;
  padding-left: 16px;
  border-left: 2px solid var(--neutral-100);
  font-size: var(--fs-big);
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.15px;
  color: var(--black-body-text);
  align-self: center;
}

.api-slide-intro > * + * {
  margin-top: 0.5rem;
}

.api-slide-divider {
  width: 100%;
  height: 2px;
  background-color: var(--neutral-100);
  margin: 1.5rem 0;
}

.api-slide-check {
  display: none;
}

.api-slide-modal {
  display: block;
}

.api-slide-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  cursor: default;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.api-slide-modal-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  height: 100vh;
  width: 100%;
  max-width: 100%;
  max-height: 100vh;
  padding: 4rem 2rem 2rem 2rem;
  position: relative;
}

.api-slide-modal-close {
  position: fixed;
  top: 2rem;
  right: 2rem;
  font-size: 2rem;
  color: #333;
  cursor: pointer;
  z-index: 10001;
}

.api-slide-modal-close:hover {
  color: #666;
}

.api-slide-main-content {
  margin-top: 1.5rem;
  width: 70%;
  height: 100%;
  padding: 1.25rem;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.5rem;
  overflow-y: auto;
}

.api-slide-main-content::-webkit-scrollbar {
  display: none;
}

.api-slide-check:checked + .api-slide-modal {
  display: block;
}

.embed-image > img {
  width: 7.7rem;
  height: 5rem;
}

.thumbnail-wrapper {
  cursor: pointer;
}

.modal-image {
  max-width: 90%;
  max-height: calc(100vh - 120px);
  object-fit: contain;
}

.modal-close-text {
  text-decoration: none;
  background: #00925e;
  color: white;

  cursor: pointer;
  font-size: var(--fs-big);
  border-radius: 16px;
  padding: 16px 20px;
}

.modal-close-text:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .api-slide-container {
    flex-direction: column !important;
    gap: 12px !important;
  }

  .api-slide-picture {
    width: 100% !important;
    height: auto !important;
    flex-shrink: 1 !important;
    overflow: visible !important;
  }

  .api-slide-picture > * {
    width: 100% !important;
    height: auto !important;
    aspect-ratio: 469 / 265 !important;
    object-fit: cover !important;
  }

  .api-slide-number {
    font-size: var(--fs-small) !important;
  }

  .api-slide-intro {
    flex: none !important;
    border-left: none !important;
    padding-left: 0 !important;
    margin-left: 0 !important;
    font-size: var(--fs-small) !important;
    line-height: 20px !important;
    text-align: left !important;
    align-self: flex-start !important;
    min-height: unset !important;
  }
}
</style>
